import { render, staticRenderFns } from "./HiddenBox.vue?vue&type=template&id=78e54b12&scoped=true&"
import script from "./HiddenBox.vue?vue&type=script&lang=ts&"
export * from "./HiddenBox.vue?vue&type=script&lang=ts&"
import style0 from "./HiddenBox.vue?vue&type=style&index=0&id=78e54b12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e54b12",
  null
  
)

export default component.exports